import { render, staticRenderFns } from "./smallProgramProduct.vue?vue&type=template&id=7128b619&scoped=true&"
import script from "./smallProgramProduct.vue?vue&type=script&lang=js&"
export * from "./smallProgramProduct.vue?vue&type=script&lang=js&"
import style0 from "./smallProgramProduct.vue?vue&type=style&index=0&id=7128b619&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7128b619",
  null
  
)

export default component.exports